import { useStaticQuery, graphql, withPrefix } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'

import { config } from '../config/global'

import { Header } from './header'

import './layout.css'

export const Layout = ({
  children,
  headless = false,
  seo,
  mainClass = '',
  iconUrl,
}) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <>
      <Helmet>
        <script>
          {`
            var gtmContainer = '${config.gtmContainer}';

            window.dataLayer = window.dataLayer || [];

            function gtag() { window.dataLayer.push(arguments); }

            if (${config.gtmRequireConsent}) {
              gtag("consent", "default", {
                ad_storage: "denied",
                analytics_storage: "denied",
              });

              // 1. Please look at utils/gtm/index.ts – any changes here
              //    must be replicated in setGtagAccepted() too.
              // 2. The localStorage key "cookieConsent" is defined there too.
              if (typeof localStorage !== 'undefined' && localStorage.getItem('cookieConsent') === 'accepted') {
                gtag('consent', 'update', {
                  analytics_storage: 'granted',
                  ad_storage: 'granted',
                })
              }
            }

            if (gtmContainer) {
              (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s),
                  dl = l != "dataLayer" ? "&l=" + l : "";
                j.async = true;
                j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                f.parentNode.insertBefore(j, f);
              })(window, document, "script", "dataLayer", gtmContainer);
            }
         `}
        </script>
      </Helmet>
      {seo && (
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="robots" content="index, follow" />
          <meta name="robots" content="index, follow" />
          {iconUrl && (
            <link rel="icon" type="image/png" href={withPrefix(iconUrl)} />
          )}
        </Helmet>
      )}
      {!headless && (
        <Header
          siteTitle={seo.title || data.site.siteMetadata?.title || `Title`}
        />
      )}
      <div className={mainClass}>
        <main>{children}</main>
        <footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  headless: PropTypes.bool,
  seo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  mainClass: PropTypes.string,
  iconUrl: PropTypes.string,
}

Layout.defaultProps = {
  headless: false,
  seo: {},
  mainClass: '',
  iconUrl: null,
}
